<template>
    <text-box :label="$t('components.MicroaudienceComposition.title')" icon="chart-bar">
      <template v-slot:info v-if="precision">
        <percent-chip :value="precision" :best="100" icon="mdi-bullseye-arrow"/>
      </template>
      <template v-slot:info-dialog>
        {{ $t('components.MicroaudienceComposition.infoDialog') }}
      </template>
      <v-row>
        <v-col cols="6">
          <v-select
            v-model="selectedWave1"
            :items="waves"
            menu-props="auto"
            :label="$t('components.MicroaudienceComposition.selectWave')"
            prepend-icon="mdi-numeric-1"
            single-line
          ></v-select>
        </v-col>
        <v-col cols="6">
          <v-select
            v-model="selectedWave2"
            :items="waves"
            menu-props="auto"
            :label="$t('components.MicroaudienceComposition.selectWave')"
            prepend-icon="mdi-numeric-2"
            single-line
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <microaudience-composition-graph v-if="selectedWave1" :data="waveObjects[waves.indexOf(selectedWave1)]" :embed="true" :slice="16" :y-axis-max="yAxisMax" />
        </v-col>
        <v-col cols="6">
          <microaudience-composition-graph v-if="selectedWave2" :data="waveObjects[waves.indexOf(selectedWave2)]" :embed="true" :slice="16" :y-axis-max="yAxisMax" />
        </v-col>
      </v-row>
    </text-box>
</template>

<script>
import TextBox from '@/components/TextBox.vue'
import PercentChip from '@/components/PercentChip.vue'
import MicroaudienceCompositionGraph from '@/components/MicroaudienceCompositionGraph.vue'

export default {
  data () {
    return {
      selectedWave1: null,
      selectedWave2: null
    }
  },
  computed: {
    yAxisMax: function () {
      if (this.waveObjects && this.waves && this.selectedWave1 && this.selectedWave2) {
        const w1 = this.waveObjects[this.waves.indexOf(this.selectedWave1)]
        const w2 = this.waveObjects[this.waves.indexOf(this.selectedWave2)]
        return Math.max(...w1.values, ...w2.values)
      } else {
        return null
      }
    },
    waves: function () {
      let waves = this.data.waves.map(wave => {
        return wave.wave_name
      })
      waves.push(this.$t('components.MicroaudienceComposition.projectedWave'))
      return waves
    },
    waveObjects: function () {
      let objects = this.data.waves
      objects.push(this.data.projected)
      return objects
    }
  },
  methods: {},
  props: {
    data: {
      type: Object,
      required: true
    },
    precision: {
      type: Number,
      required: false
    }
  },
  components: {
    TextBox,
    PercentChip,
    MicroaudienceCompositionGraph
  }
}
</script>
